import styled from 'styled-components';

import { Colors } from 'components/utils/styles/ui';

export const EnforcedOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${Colors.headerBG};
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.4rem;
`;

export const EnforcedContainer = styled.div`
  max-width: 48rem;
  width: 100%;
  background: ${Colors.white};
  border-radius: 1.2rem;
  box-shadow: 0 0.4rem 2.4rem ${Colors.blackMoreTransparent};
  padding: 3.2rem;
`;

export const EnforcedHeader = styled.div`
  text-align: center;
  margin-bottom: 2.4rem;
`;

export const EnforcedBadge = styled.span`
  display: inline-block;
  background: ${Colors.tealLighter};
  color: ${Colors.teal};
  font-size: 1.2rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
  border-radius: 0.4rem;
  margin-bottom: 1.2rem;
`;

export const EnforcedTitle = styled.h1`
  font-size: 2.2rem;
  font-weight: 600;
  color: ${Colors.text};
  margin: 0 0 0.8rem;
`;

export const EnforcedDescription = styled.p`
  font-size: 1.4rem;
  color: ${Colors.textLight};
  margin: 0;
  line-height: 1.5;
`;

export const SignOutLink = styled.button`
  display: block;
  margin: 1.6rem auto 0;
  background: none;
  border: none;
  color: ${Colors.textLighter};
  font-size: 1.3rem;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${Colors.textLight};
  }
`;
